import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import io from "socket.io-client";
import axios from "axios";
import Monitoring from './pages/Monitoring';
import BacteriaLogs from './pages/BacteriaLogs';
import Devices from './pages/Devices';
import DeviceDetail from './pages/DeviceDetail';
import Navbar from './pages/Navbar';
import "./App.css";
import DeviceLookup from "./pages/DeviceLookup";
import EAU from "./pages/Eau";

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL;
const SOCKET_SERVER_URL_API = process.env.REACT_APP_SOCKET_SERVER_URL_API;
const API_URL = process.env.REACT_APP_API_URL;

console.log("SOCKET_SERVER_URL", SOCKET_SERVER_URL);
console.log("SOCKET_SERVER_URL_API", SOCKET_SERVER_URL_API);
console.log("API_URL", API_URL);

const useSocket = () => {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        const fetchOldMessages = async () => {
            try {
                const url = SOCKET_SERVER_URL_API + API_URL;
                console.log("url", url);
                const response = await fetch(url);
                const data = await response.json();
                setMessages(data);
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
        };

        fetchOldMessages();

        const socket = io(SOCKET_SERVER_URL);
        socket.on('mqttMessage', (data) => {
            setMessages((prevMessages) => [data, ...prevMessages]);
        });

        return () => {
            socket.disconnect();
        };
    }, []);

    return messages;
};

function App() {
    const messages = useSocket();
    const [publishedMessages, setPublishedMessages] = useState([]);
    const [bacteriaLog, setBacteriaLog] = useState([]);
    const [bacteriaCount, setBacteriaCount] = useState([]);
    const [eauCount, setEauCount] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [publishedRes, bacteriaRes, bacteriaCountRes, eauCountRes] = await Promise.all([
                    axios.get(`${SOCKET_SERVER_URL_API}/published-messages`),
                    axios.get(`${SOCKET_SERVER_URL_API}/bacteria-log`),
                    axios.get(`${SOCKET_SERVER_URL_API}/bacteria-log/count`),
                    axios.get(`${SOCKET_SERVER_URL_API}/eau/count`)
                ]);

                setPublishedMessages(publishedRes.data);
                setBacteriaLog(bacteriaRes.data);
                setBacteriaCount(bacteriaCountRes.data);
                setEauCount(eauCountRes.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const socket = io(SOCKET_SERVER_URL);

        socket.on("publishedMessage", (newPublishedMessage) => {
            setPublishedMessages((prevPublished) => [newPublishedMessage, ...prevPublished]);
        });

        socket.on("bacteriaLogUpdate", (newBacteriaLog) => {
            setBacteriaLog((prevLogs) => {
                const updatedLogs = prevLogs.filter(log => log.dCore !== newBacteriaLog.dCore);
                return [newBacteriaLog, ...updatedLogs];
            });
        });

        socket.on("bacteriaCountUpdate", (newBacteriaCount) => {
            setBacteriaCount((prevCounts) => {
                const updatedCounts = prevCounts.filter(count => count.dCore !== newBacteriaCount.dCore);
                return [newBacteriaCount, ...updatedCounts];
            });
        });

	socket.on("eauCountUpdate", (newEauCount) => {  
            setEauCount((prevCounts) => {
                const updatedCounts = prevCounts.filter(count => count.dCore !== newEauCount.dCore);
                return [newEauCount, ...updatedCounts];
            });
        }
        );

        return () => {
            socket.off("publishedMessage");
            socket.off("bacteriaLogUpdate");
            socket.off("bacteriaCountUpdate");
            socket.off("eauCountUpdate");
            socket.disconnect();
        };
    }, []);

    return (
        <Router>
            <Navbar />
            <Routes>

                <Route path="/" element={<Monitoring messages={messages} publishedMessages={publishedMessages} />} />
                <Route path="/bacteria-logs" element={<BacteriaLogs logs={bacteriaLog} />} />
                <Route path="/devices" element={<Devices devices={bacteriaCount} />} />
                <Route path="/eau" element={<EAU devices={eauCount } />} />
                <Route path="/devices/:deviceId" element={<DeviceDetail />} />
		<Route path="/device/:deviceId" element={<DeviceLookup />} />
            </Routes>
        </Router>
    );
}

export default App;
